// @flow
import ExperimentClient from 'app/common/lib/ExperimentsClient/index';
import { type ExperimentGroups } from 'app/common/lib/ExperimentsClient/AExperimentsClient';

export default class SeoUnauthExperimentsClient extends ExperimentClient {
  isBot: boolean;
  logged: { [exp_name: string]: ?string } = {};

  constructor(
    active: ExperimentGroups,
    triggerable: ExperimentGroups,
    isBot: ?boolean,
    useBatching: boolean = false,
  ) {
    super(active, triggerable, useBatching);
    this.isBot = !!isBot;
  }

  v2ActivateExperiment(name: string): ?string {
    if (this.isBot) {
      const exp_name = 'seo_' + name;

      let exp_group = this.logged[exp_name];
      if (exp_group === undefined) {
        exp_group = this.active[exp_name];
        if (exp_group !== undefined) {
          this.logged[exp_name] = exp_group;
          super.v2LogExperimentGroupOverride(exp_name, exp_group, true);
        }
      }
      return exp_group;
    }

    return super.v2ActivateExperiment(name);
  }
}
